import { lazy } from "react";

const EBTerms = lazy(() => import("./../components/EB/EBTerms"));
const EBPolicy = lazy(() => import("./../components/EB/EBPolicy"));
const EBTermsOfUse = lazy(() => import("./../components/EB/EBTermsOfUse"));

export { EBPolicy, EBTerms, EBTermsOfUse };
